export default __webpack_public_path__ + "static/media/arco-ajuda.cafe042f.webp";